var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.278,
    height: 24,
    viewBox: "0 0 34.278 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M33.572-2.327a4.294,4.294,0,0,0-3.021-3.021c-2.682-.734-13.412-.734-13.412-.734s-10.729,0-13.412.706A4.381,4.381,0,0,0,.706-2.327,45.249,45.249,0,0,0,0,5.918a45.083,45.083,0,0,0,.706,8.245,4.3,4.3,0,0,0,3.021,3.021c2.71.734,13.412.734,13.412.734s10.729,0,13.412-.706a4.3,4.3,0,0,0,3.021-3.021,45.263,45.263,0,0,0,.706-8.245S34.306.356,33.572-2.327ZM13.722,11.057V.779l8.922,5.139Zm0,0",
    transform: "translate(0 6.082)"
  })));
};
export default SvgYoutube;